module.exports = __webpack_public_path__ + "img/metal_frame.21c5327f.jpg";